import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"color":"orange lighten-1","text":"","x-large":_vm.size == 'x-large',"loading":_vm.loading},on:{"click":_vm.buttonClicked}},[(_vm.iconName)?_c(VIcon,{attrs:{"large":_vm.iconSize == 'large',"left":""}},[_vm._v(_vm._s(_vm.iconName))]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }